import { useLists } from "stores/hooks/lists";
import { parse } from "lib/locale";
import { useLocale } from "stores/hooks/locale";
import { useIsAuthAdminOrgAdmin } from "stores/hooks/auth";
import { Fragment } from "react/jsx-runtime";
import {
  StyledAddButton,
  StyledDesktop,
  StyledMobile,
  StyledNavigation,
  StyledSection,
  StyledSectionContents,
} from "./navigation.styles";
import { useTranslate } from "stores/hooks/translation";
import NavigationItem from "./item";
import NavigationTitle from "./title";
import { useEffect, useState } from "react";
import NewListModal from "components/list/new-list-modal";
import { faPlus } from "components/icon-library";
import { fetchListTemplates } from "stores/actions/list-templates";

const Navigation = () => {
  const lists = useLists();
  const locale = useLocale();
  const isOrgAdmin = useIsAuthAdminOrgAdmin();
  const translate = useTranslate();
  const [newListModal, toggleNewListModal] = useState(false);

  useEffect(() => {
    // update list of available list types
    fetchListTemplates();
  }, []);

  return (
    <StyledNavigation role="navigation">
      <StyledMobile>mobile, not done yet</StyledMobile>
      <StyledDesktop>
        <StyledSection>
          <NavigationTitle>Luettelot</NavigationTitle>
          <StyledSectionContents>
            {lists.map((list) => (
              <NavigationItem key={list.uuid} to={`/admin/list/${list.uuid}`}>
                {parse(list.name, locale)}
              </NavigationItem>
            ))}

            <StyledAddButton
              postIcon={faPlus}
              type="tertiary"
              onClick={() => toggleNewListModal(true)}
            >
              Uusi luettelo
            </StyledAddButton>
          </StyledSectionContents>
        </StyledSection>
        <StyledSection>
          <NavigationTitle>Asetukset</NavigationTitle>
          <StyledSectionContents>
            <NavigationItem to="/admin/profile">Oma tili</NavigationItem>
            {isOrgAdmin && (
              <Fragment>
                <NavigationItem to="/admin/settings">
                  Organisaatio
                </NavigationItem>
                <NavigationItem
                  to="/admin/list-templates"
                  pattern={/\/admin\/list-template/}
                >
                  Luettelomallit
                </NavigationItem>
              </Fragment>
            )}
            <NavigationItem to="/admin/logout">
              {translate("nav_logout")}
            </NavigationItem>
          </StyledSectionContents>
        </StyledSection>
      </StyledDesktop>
      {newListModal && (
        <NewListModal onClose={async () => toggleNewListModal(false)} />
      )}
    </StyledNavigation>
  );
};

export default Navigation;
